import { Card, CardContent, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import "./css/SelectYourNumber.scss";

export interface IServiceOption {
    id: string;
    label: string;
}

interface IParams {
    serviceList: IServiceOption[];
    selectedService: string;
    setSelectedService(selectedService: string): void;
    titleContent?: string;
}

export const SimpleSelectYourNumber = (props: IParams) => {
    const { serviceList, selectedService, setSelectedService, titleContent } = props;
    const { t } = useTranslation(["glossary", "portin"]);

    const handleChangeSelectedService = (event: SelectChangeEvent) => {
        setSelectedService(event.target.value);
    };

    const onSelect = (selectValue: string) => {
        const service = selectValue && serviceList.find(({ id }) => id === selectValue);

        return service ? service.label : t("glossary:selectPhoneNumber");
    };

    return (
        <Card className="simple-select-number">
            <CardContent className="select-number-content">
                <form className="select-number_form">
                    {serviceList.length <= 1 && (
                        <Grid container justifyContent="center" spacing={2}>
                            <Grid item xs={12}>
                                <Typography color="inherit" variant="h4">
                                    {titleContent ?? t("portin:yourPhoneNumber")}:
                                </Typography>
                            </Grid>
                            <Grid item xs={7}>
                                <Typography color="inherit" variant="h5">
                                    {serviceList.length ? serviceList[0].label : t("portin:noPhoneNumber")}
                                </Typography>
                            </Grid>
                        </Grid>
                    )}
                    {serviceList.length > 1 && (
                        <Grid container justifyContent="center" spacing={2}>
                            <Grid item xs={12}>
                                <InputLabel htmlFor="filled-number">
                                    {titleContent ?? t("portin:selectYourNumber")}:
                                </InputLabel>
                            </Grid>
                            <Grid item sm={7} xs={9}>
                                <Select
                                    aria-label="Number select"
                                    disableUnderline
                                    displayEmpty
                                    fullWidth
                                    id="filled-number"
                                    renderValue={onSelect}
                                    value={selectedService}
                                    variant="filled"
                                    onChange={handleChangeSelectedService}
                                >
                                    {serviceList.map((service) => (
                                        <MenuItem key={service.id} value={service.id}>
                                            {service.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                        </Grid>
                    )}
                </form>
            </CardContent>
        </Card>
    );
};
